import * as angular from 'angular';
import AccountsDao  from "./accounts.dao";
import AccountsService from "./accounts.service";

export default angular.module('accounts', [])
    .service("Accounts", AccountsDao)
    .service("AccountsService", AccountsService)
    .name
